import { Link } from "react-router-dom";
import { Phone, MessageCircle, ArrowRight } from "lucide-react";
import { whatsappLink, WHATSAPP_DIGITS } from "@/lib/contact";
import { fbTrack } from "@/lib/pixel";

export default function MobileCtaBar() {
  return (
    <div
      className="md:hidden fixed bottom-0 inset-x-0 z-[70] bg-[#070707]/95 backdrop-blur-md border-t border-[#1f1f1f] pb-[env(safe-area-inset-bottom)]"
      data-testid="mobile-cta-bar"
    >
      <div className="grid grid-cols-[auto_auto_1fr] items-stretch gap-2 px-3 py-2.5">
        <a
          href={`tel:+${WHATSAPP_DIGITS}`}
          onClick={() => fbTrack("Contact", { content_name: "Chiama (barra mobile)" })}
          aria-label="Chiama Idea 360"
          className="w-12 h-12 flex items-center justify-center border border-[#FACC15]/70 text-[#FACC15] active:bg-[#FACC15] active:text-black transition-colors"
          data-testid="mobile-cta-call"
        >
          <Phone size={20} />
        </a>
        <a
          href={whatsappLink("Ciao, vi scrivo dal sito Idea 360: vorrei parlare con un consulente.")}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => fbTrack("Contact", { content_name: "WhatsApp (barra mobile)" })}
          aria-label="Scrivici su WhatsApp"
          className="w-12 h-12 flex items-center justify-center border border-[#25D366]/70 text-[#25D366] active:bg-[#25D366] active:text-black transition-colors"
          data-testid="mobile-cta-whatsapp"
        >
          <MessageCircle size={20} />
        </a>
        <Link
          to="/contatti"
          className="min-h-[48px] flex items-center justify-center gap-2 bg-[#FACC15] text-black font-bold text-sm px-4 active:bg-[#EAB308] transition-colors"
          style={{ fontFamily: "'Outfit', sans-serif" }}
          data-testid="mobile-cta-consulenza"
        >
          Richiedi una consulenza
          <ArrowRight size={16} />
        </Link>
      </div>
    </div>
  );
}
